module.exports = __webpack_public_path__ + "application/templates/default/inner/module-intimations/module-intimations.template.html";